"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const chalk_1 = require("chalk");
const leven = require("leven");
exports.levenUnknownHandler = (key, value, { descriptor, logger, schemas }) => {
    const messages = [
        `Ignored unknown option ${chalk_1.default.yellow(descriptor.pair({ key, value }))}.`,
    ];
    const suggestion = Object.keys(schemas)
        .sort()
        .find(knownKey => leven(key, knownKey) < 3);
    if (suggestion) {
        messages.push(`Did you mean ${chalk_1.default.blue(descriptor.key(suggestion))}?`);
    }
    logger.warn(messages.join(' '));
};
